import React from 'react';
import Navs from '../HomeComponent/Nav';
import Footer from '../Common/Footer';

function HealthEaseInfo() {
  return (
   <>
   
     <div className="text-center mb-8">
      <h1 className="text-3xl font-bold mb-4">Health Ease Disease Predictor</h1>
      <p className="text-lg">Health Ease Disease Predictor is an advanced tool that helps predict various diseases based on 
      the symptoms provided by the user. Simply enter your symptoms, and the predictor will analyze the data to provide you with 
      the most accurate predictions. </p>
      <p className="text-lg">Thank you for using Health Ease Disease Predictor. </p>
      <p className="text-lg font-bold mt-4 mb-4"> Happy Health 😊 </p>
    </div>
  
   </>
  );
}

export default HealthEaseInfo;
